<template>
  <div id="app">
    <loading-screen v-if="isLoading"></loading-screen>
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: true
    };
  },
  beforeUpdate() {
     this.isLoading = false
  }
};
</script>

<style lang="scss">
html {
  scroll-behavior: smooth;
}
</style>
